// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StudioOptionMobile_wrapper_1BH4D","container":"StudioOptionMobile_container_2jHk5","label":"StudioOptionMobile_label_2XiBx"};